import React from 'react'
import '../App.css';
import { useNavigate, useLocation } from "react-router-dom";

const Navigation = ({children}) => {

    const navigation = useNavigate();
    const location = useLocation();


  return (
    <div>
        <div style={{display: 'flex'}}>
            <div className='nav'>
                <div className='nav-heading'>
                    <img className='logo' src="/SiteLogo.png" alt="T" onClick={() => navigation('/home')}/>
                </div>
                <div className='links'>
                    <div className={location.pathname === '/home' ? 'link-active': 'link'} onClick={() => navigation('/home')}>
                        <svg className={location.pathname === '/home' ? 'icon-active': 'icon'} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round"strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"></path><polyline points="9 22 9 12 15 12 15 22"></polyline></svg>
                        <h3 className='link-name'>Home</h3>
                    </div>
                    <div className={location.pathname === '/projects' ? 'link-active': 'link'} onClick={() => navigation('/projects')}>
                        <svg className={location.pathname === '/projects' ? 'icon-active': 'icon'} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><polyline points="16 18 22 12 16 6"></polyline><polyline points="8 6 2 12 8 18"></polyline></svg>
                        <h3 className='link-name'>Projects</h3>
                    </div>
                    <div className={location.pathname === '/resume' ? 'link-active': 'link'} onClick={() => navigation('/resume')}>
                        <svg className={location.pathname === '/resume' ? 'icon-active': 'icon'} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></svg>
                        <h3 className='link-name'>Resume</h3>
                    </div>
                    <div className={location.pathname === '/about' ? 'link-active': 'link'} onClick={() => navigation('/about')}>
                        <svg className={location.pathname === '/about' ? 'icon-active': 'icon'} xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" ><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="16" x2="12" y2="12"></line><line x1="12" y1="8" x2="12.01" y2="8"></line></svg>
                        <h3 className='link-name'>About</h3>
                    </div>
                    <div className='getLink link' onClick={() => window.open('https://github.com/tdawsondev/')}>
                        <svg  className='icon' xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 19c-5 1.5-5-2.5-7-3m14 6v-3.87a3.37 3.37 0 0 0-.94-2.61c3.14-.35 6.44-1.54 6.44-7A5.44 5.44 0 0 0 20 4.77 5.07 5.07 0 0 0 19.91 1S18.73.65 16 2.48a13.38 13.38 0 0 0-7 0C6.27.65 5.09 1 5.09 1A5.07 5.07 0 0 0 5 4.77a5.44 5.44 0 0 0-1.5 3.78c0 5.42 3.3 6.61 6.44 7A3.37 3.37 0 0 0 9 18.13V22"></path></svg>
                        
                    </div>
                </div>
            </div>

            <div className='main-content'  style={{width: '100%'}}>
                {children}
            </div>
        </div>
    </div>
  )
}

export default Navigation